import React, { Fragment, useEffect, useState } from 'react';
import { UserContext } from '@zola-helpers/client/dist/es/@types';
import {
  PrimaryNavIdentifier,
  SecondaryNavItem,
} from '@zola-helpers/client/dist/es/constants/navConstants';

import useScrollPosition from '../../../../hooks/useScrollPosition';
import { NavWrapper } from './PostAuthDesktopNavV3.styles';
import VerticalNav from '../VerticalNav/VerticalNav';
import HorizontalNav from '../HorizontalNav/HorizontalNav';

type PostAuthDesktopNavV3Props = {
  activeLinkId?: '' | PrimaryNavIdentifier;
  activeSecondaryLink: string;
  activeTertiaryLink?: string;
  activeUniversalTab: string;
  hideAnnouncementBanner: boolean;
  isHomeStoreActive: boolean;
  secondaryNavData: SecondaryNavItem[];
  tertiaryNavData: SecondaryNavItem[];
  quickLinksData?: SecondaryNavItem[];
  userContext?: UserContext;
};

const defaultScrollPos = window.scrollY;

const PostAuthDesktopNavV3 = ({
  activeLinkId,
  activeSecondaryLink,
  activeUniversalTab,
  hideAnnouncementBanner,
  isHomeStoreActive,
  secondaryNavData,
  tertiaryNavData,
  userContext,
  quickLinksData,
  activeTertiaryLink,
}: PostAuthDesktopNavV3Props): JSX.Element => {
  const [hideContentOnScroll, setHideContentOnScroll] = useState(defaultScrollPos !== 0);

  const { direction } = useScrollPosition();

  // Show minimized nav until user reaches top of page
  const currentHideContentOnScroll =
    direction === 'down' || (direction === 'up' && window.scrollY > 0);

  useEffect(() => {
    if (currentHideContentOnScroll !== hideContentOnScroll) {
      setHideContentOnScroll(currentHideContentOnScroll);
    }
  }, [currentHideContentOnScroll, hideContentOnScroll]);

  if (!userContext) {
    return <Fragment />;
  }

  return (
    <NavWrapper>
      <VerticalNav activeLinkId={activeLinkId} userContext={userContext} />
      <HorizontalNav
        activeLinkId={activeLinkId}
        activeSecondaryLink={activeSecondaryLink}
        activeUniversalTab={activeUniversalTab}
        hideAnnouncementBanner={hideAnnouncementBanner}
        hideContentOnScroll={hideContentOnScroll}
        isHomeStoreActive={isHomeStoreActive}
        secondaryNavData={secondaryNavData}
        tertiaryNavData={tertiaryNavData}
        quickLinksData={quickLinksData}
        userContext={userContext}
        activeTertiaryLink={activeTertiaryLink}
      />
    </NavWrapper>
  );
};

export default PostAuthDesktopNavV3;
